import Fallback from './ResourceGroup.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./ResourceGroup.page'),
});
